export default __webpack_public_path__ + "static/media/365.1844e99d.png";